import PageTemplate from "../templates/PageTemplate";
import abi from "../abi/abi.json";
import {
  useAccount,
  useContractRead,
  useContractReads,
  useContractWrite,
  usePrepareContractWrite,
} from "wagmi";
import { useEffect, useMemo, useState } from "react";
import { MerkleTree } from "merkletreejs";
import keccak256 from "keccak256";

export const yakoContract = {
  address: process.env.REACT_APP_CONTRACT_ADDRESS,
  abi: abi,
};

const MintPage = () => {
  const [isClaimable, setIsClaimable] = useState(false);

  const { address } = useAccount();
  const { data: readData } = useContractReads({
    contracts: [
      {
        ...yakoContract,
        functionName: "isPublicMintActive",
      },
      {
        ...yakoContract,
        functionName: "isWhitelistMintActive",
      },
      {
        ...yakoContract,
        functionName: "totalSupply",
      },
      { ...yakoContract, functionName: "whitelistClaimed", args: [address] },
      { ...yakoContract, functionName: "publicClaimed", args: [address] },
      { ...yakoContract, functionName: "MAX_SUPPLY" },
    ],
  });

  const { config: publicMintConfig, error: publicMintError } =
    usePrepareContractWrite({
      ...yakoContract,
      functionName: "publicMint",
    });
  const { write: publicMint, data: publicMintData } =
    useContractWrite(publicMintConfig);

  const { data: merkleRoot } = useContractRead({
    ...yakoContract,
    functionName: "merkleRoot",
  });

  const merkleProof = useMemo(() => {
    if (
      merkleRoot === undefined ||
      merkleRoot ===
        "0x0000000000000000000000000000000000000000000000000000000000000000"
    ) {
      return;
    }
    const addresses = require(`../../merkleroot/${merkleRoot}.json`);
    const tree = new MerkleTree(addresses, keccak256, {
      hashLeaves: true,
      sortPairs: true,
    });
    const leaf = keccak256(address ?? "");
    const merkleProof = tree.getHexProof(leaf);
    return merkleProof;
  }, [address, merkleRoot]);

  const { config: allowlistMintConfig, error: allowlistMintError } =
    usePrepareContractWrite({
      ...yakoContract,
      functionName: "whitelistMint",
      args: [merkleProof],
    });

  const { write: allowlistMint, data: allowlistMintData } =
    useContractWrite(allowlistMintConfig);

  useEffect(() => {
    if (
      merkleRoot ===
        "0x0000000000000000000000000000000000000000000000000000000000000000" ||
      merkleRoot === undefined ||
      readData?.[1] !== true
    ) {
      return;
    }
    const listJson = require(`../../merkleroot/${merkleRoot}.json`);
    const leaf = listJson.find(
      (v: string) => v.toLowerCase() === address?.toLowerCase()
    );
    setIsClaimable(leaf !== undefined);
  }, [merkleRoot, address, readData]);

  return (
    <PageTemplate
      maxSupply={readData?.[5]}
      totalSupply={readData?.[2]}
      isPublicMintActive={readData?.[0]}
      publicClaimed={readData?.[4]}
      publicMint={publicMint}
      publicMintData={publicMintData}
      publicMintError={publicMintError}
      isWhitelistMintActive={readData?.[1]}
      whitelistClaimed={readData?.[3]}
      allowlistMint={allowlistMint}
      allowlistMintData={allowlistMintData}
      allowlistMintError={allowlistMintError}
      isClaimable={isClaimable}
    />
  );
};

export default MintPage;
